import React from "react";
import FooterComponent from "./footer.component";
import { useSelector } from "react-redux";

export default function FooterContainer({
  type
}) {
  const lang = useSelector(state => state.constant.languages);
  return <FooterComponent  type={type} lang={lang}/>
}